import React from 'react';
import ProposalRichText from './ProposalRichText';
import { puckHorizontalAlignField } from '../../../puck/fields/puckHorizontalAlignField';
import { puckVerticalAlignField } from '../../../puck/fields/puckVerticalAlignField';
import { puckVisibilityField } from '../../../puck/fields/puckVisibilityField';
import { puckColorField } from '../../../puck/fields/createPuckColorField';
import { puckSectionField } from '../../../puck/fields/puckSectionField';
import { proposalHeadingBackground } from '../../../utils/proposalTextStyle';
import { resolveVariableBoxFields, variableBoxFormFields } from '../../../puck/fields/variableBoxFormFields';
import { WEB_TEXT_BLOCK_TYPE } from '../../../utils/siteVariableBoxes';

const proposalRichTextConfig = {
  label: 'Texte',
  defaultProps: {
    html: '', alignVertical: 'center', isVisible: true,
  },
  /* Le contenu s'édite sur le canvas (Tiptap + bubble menu) : la sidebar ne
     porte que les attributs du bloc. */
  fields: {
    isVisible: puckVisibilityField(),

    _section1: puckSectionField('Style'),
    /* Un fond hérité de la configuration du document n'était réglable nulle
       part : ni ici, ni dans le Bloc parent, ni au surlignage du texte. */
    backgroundColor: puckColorField('Couleur de fond', {
      allowTransparent: true,
      /* Tant que rien n'est choisi, le bloc porte le fond posé par le proposal
         à la génération : le champ affiche cette couleur-là, celle qui est
         réellement rendue, au lieu d'un blanc que personne n'a choisi. */
      emptyIsInherited: true,
      readInherited: (props, { proposalStyles }) => (
        props?.textStyle?.backgroundColor
        || proposalHeadingBackground(proposalStyles, props?.headingLevel)
        || ''
      ),
    }),

    _section2: puckSectionField('Affichage'),
    /* Place du bloc dans sa colonne. L'alignement du texte lui-même reste dans
       la barre flottante du canvas, avec le reste de la mise en forme. */
    alignHorizontal: puckHorizontalAlignField(),
    alignVertical: puckVerticalAlignField(),

    /* Box texte du formulaire (text_variable du classique). */
    ...variableBoxFormFields({ withFormSection: true }),
  },
  resolveFields: (data, { fields }) => resolveVariableBoxFields(
    { type: WEB_TEXT_BLOCK_TYPE, props: data.props },
    fields,
    { alwaysHideable: true },
  ),
  render: (props) => <ProposalRichText {...props} />,
};

export default proposalRichTextConfig;
